<template>
    <v-dialog v-model="dialog" max-width="500" persistent>
        <v-toolbar color="indigo" dark>
            <v-toolbar-title color="indigo" dark>{{!!payment ? 'Editar' : 'Generar'}} cobro personalizado</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="hide">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card class="mt-0">
            <v-card-text class="pt-0">
                <v-form v-model="valid">
                    <v-container >
                        <v-layout wrap align-center justify-center>
                            <v-flex xs12 >
                                <custom-payment-form
                                    :payment="payment"
                                    @change:valid="validPayment = $event"
                                    @change="onPaymentChange" />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="hide">Cancelar</v-btn>
                <v-btn
                        :loading="loading"
                        :disabled="!validPayment"
                        color="primary"
                        depressed
                        @click="savePayment">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {getLabel} from '@/utils/Institution'

    import {mapState, mapMutations, mapGetters} from 'vuex'
    import CustomPaymentForm from "./CustomPaymentForm";

    export default{
        components: {CustomPaymentForm},
        props: {
            payment: {
                type: Object
            },
            clientId: {
                type: Number
            }
        },
        data(){
            return {
                dialog: false,
                other: false,
                payload: null,
                loading: false,
                validPayment: false,
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            getLabel,
            onPaymentChange(val){
                this.payload = val
            },
            show(){
                this.dialog = true
            },
            hide(){
                this.dialog = false
            },
            async savePayment(){

                var vm = this
                if(vm.loading) return

                vm.loading = true
                const {amount, comments, labels, status_detail} = vm.payload

                let response
                if(vm.payment){
                    response = await ApiUtils.makePatch(
                        `provider/payments/custom/${vm.payment.id}`,
                        null,
                        {
                            amount: amount.toString().replace(/\./g, ''),
                            comments: comments,
                            labels: labels,
                            status_detail: status_detail || 'pending'
                        }
                    )
                }else{
                    response = await ApiUtils.makePost(
                        `provider/${vm.currentProvider.id}/payment/custom`,
                        {
                            client_id: vm.clientId,
                            amount: amount.toString().replace(/\./g, ''),
                            comments: comments,
                            labels: labels
                        }
                    )
                }

                vm.loading = false

                if(response.ok){
                    const json = await response.json()
                    vm.$emit('success', json.result.payment)
                    vm.showSnackBar({
                        text: 'Cobro generado correctamente',
                        color: 'success'
                    })
                    vm.hide()
                }else{
                    const json = await response.json()
                    vm.showSnackBar({
                        text: json.message,
                        color: 'error'
                    })
                }

            }
        },
        computed: {
          ...mapState(['currentProvider', 'currentUser']),
          ...mapGetters(['specialistSettings']),
        },
        watch:{}

    }
</script>
